import Phaser from 'phaser';
import { CST } from '../../../CST';
import { Score } from '../../../controller/score.js';

var pos = 0;

export default class Storyboard_7 extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.STORYBOARD_7);
	}

	init() {
		pos = 0;
	}

	preload() {
		this.load.image('helping-gran-bg', 'assets/Storyboards/helpinggran_background.png');
	}

	create(data) {
		const map = this.add.image(0, 0, 'helping-gran-bg').setOrigin(0);

		const cam = this.cameras.main;
		cam.setBounds(0, 0, 4401, 9465); //Left, Top, X Limit, Y Limit
		cam.setZoom(0.8); //0.8
		cam.centerOn(1100, 600); //1100, 800

		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});

		this.score = new Score(this);
		this.User_ID = data.User_ID;

		data.next
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos++;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 1:
							cam.pan(3200, 650, 1000);
							cam.zoomTo(0.75, 1000);
							break;
						case 2:
							cam.pan(0, 2150, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 3:
							cam.pan(0, 3700, 1000);
							break;
						case 4:
							cam.pan(1200, 5300, 1000);
							cam.zoomTo(0.8, 1000);
							break;
						case 5:
							cam.pan(3350, 5300, 1000);
							break;
						case 6:
							cam.pan(0, 6850, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 7:
							cam.pan(0, 8490, 1000);
							break;
						case 8:
							pos = 0;
							data.next.setVisible(false);
							data.previous.setVisible(false);
							data.pause.setVisible(false);
							this.scene.resume(CST.SCENES.MAIN_QUESTIONS, {
								User_ID: this.User_ID,
								story: 7,
							});
							this.scene.stop();
							break;
					}
				},
				this,
			);

		data.previous
			.setInteractive({
				useHandCursor: true,
			})
			.on(
				'pointerdown',
				() => {
					this.clickSound.play();
					pos--;
					data.next.disableInteractive();
					data.previous.disableInteractive();
					setTimeout(() => {
						data.next.setInteractive();
						data.previous.setInteractive();
					}, 1500);
					switch (pos) {
						case -1:
							pos = 0;
							break;
						case 0:
							cam.pan(1100, 600, 1000);
							break;
						case 1:
							cam.pan(3200, 650, 1000);
							cam.zoomTo(0.75, 1000);
							break;
						case 2:
							cam.pan(0, 2150, 1000);
							break;
						case 3:
							cam.pan(0, 3700, 1000);
							cam.zoomTo(0.35, 1000);
							break;
						case 4:
							cam.pan(1200, 5300, 1000);
							break;
						case 5:
							cam.pan(3350, 5300, 1000);
							cam.zoomTo(0.8, 1000);
							break;
						case 6:
							cam.pan(0, 6850, 1000);
							break;
						case 7:
							cam.pan(0, 8490, 1000);
							break;
					}
				},
				this,
			);
	}
}
